(function () {
  function zonedTimestamp(value, timeZone) {
    var parts = String(value || '').trim().split(/[ T]/);
    var date = (parts[0] || '').split('-').map(Number);
    var time = (parts[1] || '00:00:00').split(':').map(Number);
    if (date.length < 3 || date.some(function (part) { return !part && part !== 0; })) return null;

    var utcGuess = Date.UTC(date[0], date[1] - 1, date[2], time[0] || 0, time[1] || 0, time[2] || 0);
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone || 'America/Los_Angeles',
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    var shown = {};
    formatter.formatToParts(new Date(utcGuess)).forEach(function (part) {
      if (part.type !== 'literal') shown[part.type] = Number(part.value);
    });
    var shownUtc = Date.UTC(shown.year, shown.month - 1, shown.day, shown.hour, shown.minute, shown.second);
    return utcGuess - (shownUtc - utcGuess);
  }

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function endTime(root) {
    if (root.dataset.mode === 'fixed') {
      return zonedTimestamp(root.dataset.end, root.dataset.timezone);
    }

    var hours = Number(root.dataset.hours) || 2;
    var key = 'amp-promo-strip-' + root.dataset.sectionId + '-' + hours;
    var stored = 0;
    try {
      stored = Number(window.localStorage.getItem(key));
      if (!stored || stored <= Date.now()) {
        stored = Date.now() + hours * 60 * 60 * 1000;
        window.localStorage.setItem(key, String(stored));
      }
    } catch (error) {
      stored = Date.now() + hours * 60 * 60 * 1000;
    }
    return stored;
  }

  function boot(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var deadline = endTime(root);
    var units = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };

    function render() {
      var remaining = Math.max(0, deadline - Date.now());
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (units.days) units.days.textContent = pad(days);
      if (units.hours) units.hours.textContent = pad(hours);
      if (units.minutes) units.minutes.textContent = pad(minutes);
      if (units.seconds) units.seconds.textContent = pad(seconds);

      if (remaining === 0 && root.dataset.hideEnded === 'true') {
        root.hidden = true;
        window.clearInterval(root._promoTimer);
      }
    }

    render();
    root._promoTimer = window.setInterval(render, 1000);
  }

  function bootAll(scope) {
    (scope || document).querySelectorAll('[data-promo-strip]').forEach(boot);
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-promo-strip]').forEach(function (root) {
      window.clearInterval(root._promoTimer);
      delete root.dataset.ready;
      boot(root);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else {
    bootAll();
  }
})();
